
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../config';

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { add_icon, delete_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { MdOutlineFeed } from "react-icons/md";
import { decrypt, encrypt } from '../Crypto';
import { connect } from 'react-redux';
import { SetId } from './redux/actions';
import BackDrop from './Backdrop';
import { VscThreeBars } from "react-icons/vsc";
import Switch from "react-switch";
import { Button, Typography } from '@mui/material';

import { Collapse } from "react-collapse";
import { FiImage, FiClock, FiSettings } from "react-icons/fi";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

const userdb = db.ref('userdb');

const Sign_up = db.ref('Sign_up');
const customerdb = db.ref('customerdb');

const height = window.innerHeight;
const width = window.innerWidth;

const room = db.ref('Sign_up')

const DATA = [
    {
        id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
        title: 'Dancer',
        uri: 'https://randomuser.me/api/portraits/men/32.jpg',
        name: 'Pablo '
    },
    {
        id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/79.jpg',
        name: 'Rodriguez '
    },
    {
        id: '58694a0f-3da1-41f-bd96-145571e29d72',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/31.jpg',
        name: 'Maxi milianos '
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d7',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/30.jpg',
        name: 'Leo'
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d2',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/42.jpg',
        name: 'Golin'
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d7',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/70.jpg',
        name: 'Leo'
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d2',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/42.jpg',
        name: 'Golin'
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d7',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/30.jpg',
        name: 'Leo'
    },
    {
        id: '58694a0f-3da1-471f-bd96-145571e29d2',
        title: 'Dancer ',
        uri: 'https://randomuser.me/api/portraits/men/52.jpg',
        name: 'Golin'
    }
];


function Settings({ items, SetId }) {

    const [aiOpen, setAiOpen] = useState(false);

    const AiSubItem = ({ icon, label, onClick }) => (
        <div
            onClick={onClick}
            style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 14,
                height: 52,
                paddingLeft: 18,
                paddingRight: 20,
                marginBottom: 8,
                borderRadius: 12,
                backgroundColor: "transparent",
            }}
        >
            <div
                style={{
                    width: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9AA4B2",
                }}
            >
                {icon}
            </div>

            <span
                style={{
                    fontSize: label === "Create Images" ? 13 : 15,
                    fontWeight: 600,
                    lineHeight: "1",
                    color: "#9AA4B2",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </span>
        </div>
    );

    const AiLeftSubMenuDesktop = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.14,
                    //  alignSelf: "center",
                    marginTop: 8,
                    // justifyContent: "center", // center whole block
                    marginLeft: 52,
                }}
            >
                {/* inner aligned block */}

                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                    }}
                />

                {/* menu items */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start", // text stays left aligned
                    }}
                >
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => {
                            if (items.devices > 0) {
                                navigate("/AICreate")
                                // Do something if devices are available
                            }
                            else toast('Add a Boom Display Device before using Ai')
                        }}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>


            </div>
        );
    };


    const AiLeftSubMenuMobile = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.35,
                    alignSelf: "center",
                    marginTop: 8,
                }}
            >
                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                        marginLeft: 12,
                    }}
                />

                <div style={{ flex: 1 }}>
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => navigate("/AICreate")}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>
            </div>
        );
    };



    console.log('Items ', items)

    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('display')
            if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
            else { navigate('/') }
        }
    }, [items])

    const [two_fa, setTwo_fa] = useState(false)



    // const {state} = useLocation();
    // const user_id = state.item
    // console.log ('ID',user_id) 

    const key = items.myid == null ? null : items.myid.id

    useEffect(() => {
        if (key != null) {
            const subscribe = Sign_up.child(String(key)).child('secret').on('value', (snapshot) => {
                console.log('Snapshot ', snapshot.val())
                if (snapshot != undefined && snapshot != null && snapshot.val() != null) {
                    setTwo_fa(true)
                }
                else setTwo_fa(false)
            });
            return () => {
                Sign_up.child(String(key)).child('secret').off('value', subscribe);
            }
        }
    }, [key])


    async function turnOff() {
        if (key != null) {
            await Sign_up.child(String(key)).child('secret').remove()
            setTwo_fa(false)
        }
    }

    async function turn_on() {
        if (key != null) {
            await Sign_up.child(String(key)).update({ secret: secret })
            //setTwo_fa(false)
            setSecret(null)
            setPopTurn(false)
        }
    }

    // console.log('Key ', key)


    const navigate = useNavigate();


    const state = useLocation()

    useEffect(() => {
        if (state.state != undefined) {
            if (state.state.add != undefined) {
                setAdd(true)
            }
        }
    }, [state])

    console.log('State ', state)


    const [add, setAdd] = useState(false)





    const [width, setwidth] = useState(window.innerWidth);
    const [height, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const windowSizeHandler = () => {
            setwidth(window.innerWidth)
            setWindowHeight(window.innerHeight)
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const isMobile = width <= 768;

    const drawerW = isMobile ? width * 0.80 : width * 0.20;

    const [drawerOpen, setDrawerOpen] = useState(false);

    function handleOpenDrawerButton() {
        setDrawerOpen(!drawerOpen);
    }

    function handleBackdropClick() {
        setDrawerOpen(false);
    }


    let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";

    const [pop_turn, setPopTurn] = useState(false)
    const [url, setUrl] = useState(null)

    const [secret, setSecret] = useState(null)

    async function rqeuestQrCode() {
        // Logic to generate TOTP code
        try {
            let response = await fetch(`https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/generate?userId=${key}&email=${items.myid.Email}`);
            response = await response.json();
            console.log('Response from server:', response);
            setUrl(response.ImageData);
            setPopTurn(true)
            setSecret(response.secret);
        } catch (error) {
            console.log()
        }

    }

    // ✅ 3) One-line titles in mobile drawer
    const mobileDrawerTitleStyle = (maxW) => ({
        color: "white",
        marginLeft: 18,
        fontWeight: "600",
        fontSize: 15,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: maxW,
        display: "block",
    });

    return (
        !isMobile ? <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>



            <div style={{ backgroundColor: '#080A0C', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: width * 0.20, textAlign: 'center' }}>


                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />

                </div>

                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Devices</text>

                    </div>

                </div>

                <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Content</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Calendar</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div
                    onClick={() => setAiOpen(!aiOpen)}
                    style={{
                        cursor: "pointer",
                        marginTop: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        width: 0.18 * width,
                        padding: 10,
                        alignSelf: "center",
                        alignItems: "center",
                        height: 52,
                    }}
                >
                    <div
                        style={{
                            width: 0.14 * width,
                            flexDirection: "row",
                            display: "flex",
                            padding: 10,
                            borderRadius: 6,
                            height: 52,
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <text style={{ color: "white", marginLeft: 30, fontWeight: "600", fontSize: 16 }}>
                            AI Generator
                        </text>

                        <img
                            src={require("../assets/right.png")}
                            style={{
                                height: 41,
                                width: 20,
                                transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
                                transition: "transform 200ms ease",
                            }}
                        />
                    </div>
                </div>

                <Collapse isOpened={aiOpen}>
                    <AiLeftSubMenuDesktop />
                </Collapse>

                <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ position: 'relative', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Subscription</text>
                        <div style={{ height: 41, width: 20 }} />
                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}
                    </div>
                </div>

                <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ backgroundColor: '#181E25', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Settings</text>
                        <img src={require('../assets/right.png')} style={{ height: 41, width: 20 }} />
                    </div>
                </div>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.74) - 105 }}>
                        <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Settings</text>
                        {
                            /*
                            <div style={{ marginLeft: 6, marginTop: 4 }}>
                                <stripe-buy-button
                                    buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                    publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                                >
                                </stripe-buy-button>
                            </div>
                            */
                        }
                    </div>
                    <div onClick={() => {
                        navigate('/')
                        localStorage.removeItem('display')
                        localStorage.removeItem('devices')
                        SetId(null)
                    }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                        <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                    </div>
                </div>



                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 100 }}>


                    <div style={{ backgroundColor: '#181E25', display: 'flex', width: 600, height: 550, alignSelf: 'center', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', borderRadius: 15 }}>

                        <img src={require('../logo1.png')} style={{ height: 123, width: 242, marginTop: 15 }} />


                        <input value={items.myid != null ? items.myid.Name : ''} disabled placeholder='Email' style={{ marginTop: 20, borderRadius: 10, width: 475, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" />

                        <input value={items.myid != null ? items.myid.Email : ''} disabled placeholder='Email' style={{ marginTop: 20, borderRadius: 10, width: 475, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" />

                        <div style={{ marginTop: 20, borderRadius: 10, width: 475, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <text>Turn on 2FA</text>
                            <Switch onChange={() => {
                                if (two_fa) {
                                    turnOff()
                                }
                                else {
                                    rqeuestQrCode()
                                }
                            }} checked={two_fa} onColor="#86d3ff"
                                onHandleColor="#26B8AD"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={48} />

                        </div>



                    </div>



                </div>

            </div>



            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

            {pop_turn ? <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 630, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 130, left: (width - 630) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 600, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

                <div style={{ display: 'flex', flexDirection: 'column', width: 600, justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', height: 550 }}>

                    <IoIosCloseCircle onClick={() => setPopTurn(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <text style={{ color: '#EDEDED', fontSize: 24, fontWeight: '700', marginTop: 20, fontFamily: "Open Sans" }}>Use your authenticator app to scan the code below:</text>
                    <img src={url} style={{ height: 200, width: 200, marginTop: 20, alignSelf: 'center' }} />
                    <text style={{ cursor: 'pointer', width: 400, alignSelf: 'center', textAlign: 'left', fontSize: 22, fontWeight: '400', color: '#EDEDED', marginTop: 10, fontFamily: "Open Sans" }}>Alternatively, you can manually type in the following secret</text>
                    <input value={secret} disabled style={{ marginTop: 20, borderRadius: 10, width: 480, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" />

                    <Button onClick={() => turn_on()} style={{ width: 400, height: 53, marginTop: 15, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >C</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >ontinue</Typography><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700', marginLeft: 10 }} >2FA A</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >ctivation</Typography></Button>
                    <Button onClick={() => setPopTurn(false)} style={{ width: 400, height: 53, marginTop: 15, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#ee4037', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >C</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >ancel</Typography></Button>

                </div>
            </div> : null}


        </div> : <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>

            <div className={drawerClasses} style={{ width: drawerW }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />

                </div>

                {/* CONTENT */}
                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div> : null}

                {/* DEVICES */}
                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Devices</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>


                {/* CONTENT */}
                <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Content</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>


                {/* CALENDAR */}
                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Calendar</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>AI Generator</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>


                {/* SUBSCRIPTION */}
                <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ position: 'relative', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Subscription</text>
                        <div style={{ height: 30, width: 20 }} />
                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}
                    </div>
                </div>

                <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, boxSizing: "border-box" }}>
                    <div style={{ backgroundColor: '#181E25', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
                        <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
                    </div>

                </div>


                <div onClick={() => {
                    navigate('/')
                    localStorage.removeItem('display')
                    localStorage.removeItem('devices')
                    SetId(null)
                }} style={{ left: ((0.35 * width) - 100) / 2, position: 'absolute', bottom: 10, alignContent: 'center', cursor: 'pointer', alignSelf: 'center', width: 150, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                    <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                </div>

            </div>

            {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}




            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 0, width: width, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>
                        <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
                        </div>
                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
                    </div>

                </div>



                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, height: height - 100 }}>

                    <text style={{ marginTop: 8, fontSize: 20, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>  Settings</text>



                    <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


                        <img src={require('../logo1.png')} style={{ height: 123, width: 242, marginTop: 15 }} />


                        <input value={items.myid.Name} placeholder='Email' place style={{ marginTop: 20, borderRadius: 10, width: 315, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" />

                        <input value={items.myid.Email} placeholder='Email' place style={{ marginTop: 20, borderRadius: 10, width: 315, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" />

                        <div style={{ marginTop: 20, borderRadius: 10, width: 315, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <text>Turn on 2FA</text>
                            <Switch onChange={() => {
                                if (two_fa) {
                                    turnOff()
                                }
                                else {
                                    rqeuestQrCode()
                                }
                            }} checked={two_fa} onColor="#86d3ff"
                                onHandleColor="#26B8AD"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={48} />

                        </div>

                    </div>


                </div>

            </div>



            {pop_turn ? <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 300, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 100, left: (width - 300) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 570, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

                <IoIosCloseCircle onClick={() => setPopTurn(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />



                <text style={{ color: '#EDEDED', fontSize: 18, fontWeight: '700', marginTop: 35, fontFamily: "Open Sans" }}>Use your authenticator app to scan the code below:</text>

                <img src={url} style={{ height: 160, width: 160, marginTop: 20, alignSelf: 'center' }} />

                <text style={{ cursor: 'pointer', width: 280, alignSelf: 'center', textAlign: 'left', fontSize: 16, fontWeight: '400', color: '#EDEDED', marginTop: 10, fontFamily: "Open Sans" }}>Alternatively, you can manually type in the following secret</text>
                <textarea value={secret} disabled style={{ marginTop: 10, borderRadius: 10, width: 280, backgroundColor: 'transparent', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 16, fontWeight: 400, paddingLeft: 10, fontFamily: "Open Sans", }} type="text" />

                <Button onClick={() => turn_on()} style={{ width: 280, height: 53, marginTop: 15, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >C</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >ontinue</Typography><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700', marginLeft: 10 }} >2FA A</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >ctivation</Typography></Button>
                <Button onClick={() => setPopTurn(false)} style={{ width: 280, height: 53, marginTop: 15, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#ee4037', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >C</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >ancel</Typography></Button>


            </div> : null}


            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

        </div>
    );
}


const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId })(Settings)

/*   
 <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
    <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
*/